import React, { useContext, useMemo } from 'react';

import { PageDataContextType, PageDataProviderProps } from './types';

const PageDataContext = React.createContext<PageDataContextType | undefined>(
  undefined,
);

export const PageDataProvider: React.FC<PageDataProviderProps> = ({
  children,
  reactRoot,
  title,
  url,
  widgetId,
}) => {
  const state = useMemo(() => ({ reactRoot, title, url, widgetId }), [
    reactRoot,
    title,
    url,
    widgetId,
  ]);

  return (
    <PageDataContext.Provider value={state}>
      {children}
    </PageDataContext.Provider>
  );
};

export function usePageData() {
  const context = useContext(PageDataContext);

  if (context === undefined) {
    throw new Error('usePageData must be used within a PageDataProvider');
  }

  return context;
}
